import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";

export function useSlackExternalApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      sendSlackMessageExternal: async (input: {
        channelName: string;
        message: string;
      }) =>
        apiResolver<{ message: string }>(
          api.post("/platform/slack-external/send-message", input)
        ),
    }),
    [api]
  );
}
